import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  height: 12rem;
`

LoadingWrapper.displayName = 'LoadingWrapper'

export const LabelWrapper = styled.label`
  height: 12rem;
  border: 1px dashed var(--gray-500);
`

LabelWrapper.displayName = 'LabelWrapper'

export const SendImageButton = styled.button`
  border-radius: 0.25rem;

  &:focus,
  :active {
    outline: 0;
  }
`
SendImageButton.displayName = 'SendImageButton'
